

    /**
     * Typecast a value to a String, using an empty string value for null or
     * undefined.
     */
    function toString(val){
        return val == null ? '' : val.toString();
    }

    module.exports = toString;





/*****************
 ** WEBPACK FOOTER
 ** ./~/mout/lang/toString.js
 ** module id = 15
 ** module chunks = 0
 **/